/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useState } from 'react';
import cx from 'clsx';
import { useStaticQuery, graphql } from 'gatsby';
import { Container } from '@hiro-ui/bootstrap';
import styled from 'styled-components';

import { SiteTitleQuery } from '../../../graphql-types';
import { Result } from '../types';
import { useScrollPassed } from '../../templates/captureScroll';

import { Header } from './Header';
import { Banner, BannerProps } from './Banner';
import { Footer } from './Footer';
import SEO, { SEOProps } from './SEO';
import { Results } from './Results';
import { SidebarProps, Sidebar } from './Sidebar';

export interface LayoutProps {
  banner?: BannerProps;
  seo?: SEOProps;
  sidebar?: SidebarProps;
  hasSidebar?: boolean;
  hasToC?: boolean;
}

const Main = styled.main`
  position: relative;
`;

export const Layout: React.FC<LayoutProps> = ({
  children,
  seo = {},
  banner = {},
  sidebar = {},
  hasSidebar,
  hasToC,
}) => {
  const [searchResults, setSearchResults] = useState<Result>(null);
  const data = useStaticQuery<SiteTitleQuery>(graphql`
    query SiteTitle {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const hasPassed = useScrollPassed(205);

  const mainClassnames = cx({ scrolled: hasPassed });

  return (
    <>
      <SEO {...seo} />
      <Header
        siteTitle={data.site.siteMetadata.title}
        onSearch={setSearchResults}
      />
      {searchResults !== null ? (
        <Banner
          main="Search Results"
          subtitle={searchResults?.length === 0 ? (
            'Sorry! Your search term has 0 results'
          ) : (
            `Your search term has the following ${searchResults?.length || 0} results:`
          )}
          secondary={searchResults && searchResults.length === 0}
        />
      ) : (
        <Banner {...banner} />
      )}
      <Container fluid={hasSidebar || hasToC}>
        <Main className={mainClassnames}>
          {searchResults === null && hasSidebar && <Sidebar {...sidebar} />}
          {searchResults !== null ? (
            <Results data={searchResults} />
          ) : (
            children
          )}
        </Main>
        <Footer />
      </Container>
    </>
  );
};
